(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb5f6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb5f6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kg4TJ", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ebf919ea45c66e3a$export$6503ec6e8aabbaf; }, function (v) { return $ebf919ea45c66e3a$export$6503ec6e8aabbaf = v; });
var $ebf919ea45c66e3a$export$6503ec6e8aabbaf;
var $ebf919ea45c66e3a$export$f7ad0328861e2f03;
"use strict";
var $ebf919ea45c66e3a$var$mapping = new Map();
function $ebf919ea45c66e3a$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ebf919ea45c66e3a$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ebf919ea45c66e3a$var$resolve(id) {
    var resolved = $ebf919ea45c66e3a$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ebf919ea45c66e3a$export$6503ec6e8aabbaf = $ebf919ea45c66e3a$var$register;
$ebf919ea45c66e3a$export$f7ad0328861e2f03 = $ebf919ea45c66e3a$var$resolve;

});

parcelRegister("gf0ph", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $bd2e5cd39df444ae$export$bdfd709ae4826697; }, function (v) { return $bd2e5cd39df444ae$export$bdfd709ae4826697 = v; });
var $bd2e5cd39df444ae$export$bdfd709ae4826697;
var $bd2e5cd39df444ae$export$c9e73fbda7da57b6;
var $bd2e5cd39df444ae$export$5a759dc7a1cfb72a;
"use strict";
var $bd2e5cd39df444ae$var$bundleURL = {};
function $bd2e5cd39df444ae$var$getBundleURLCached(id) {
    var value = $bd2e5cd39df444ae$var$bundleURL[id];
    if (!value) {
        value = $bd2e5cd39df444ae$var$getBundleURL();
        $bd2e5cd39df444ae$var$bundleURL[id] = value;
    }
    return value;
}
function $bd2e5cd39df444ae$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $bd2e5cd39df444ae$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $bd2e5cd39df444ae$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $bd2e5cd39df444ae$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$bd2e5cd39df444ae$export$bdfd709ae4826697 = $bd2e5cd39df444ae$var$getBundleURLCached;
$bd2e5cd39df444ae$export$c9e73fbda7da57b6 = $bd2e5cd39df444ae$var$getBaseURL;
$bd2e5cd39df444ae$export$5a759dc7a1cfb72a = $bd2e5cd39df444ae$var$getOrigin;

});

parcelRegister("84XYd", function(module, exports) {

module.exports = (parcelRequire("gf0ph")).getBundleURL("jH5WZ") + "cubetexture.0f759e03.png";

});

var $edea1b81ef77ef93$exports = {};


(parcelRequire("kg4TJ")).register((parcelRequire("gf0ph")).getBundleURL("jH5WZ"), JSON.parse('["jH5WZ","index.0990d8cb.js","38ivf","cubetexture.0f759e03.png"]'));

var $130b0873670d25cf$export$2e2bcd8739ae039 = `
precision mediump float;
     
// Passed in from the vertex shader.
varying vec2 vTextureCoord;
 
// The texture.
uniform sampler2D uSampler;
 
void main() {
   gl_FragColor = texture2D(uSampler, vTextureCoord);
}
`;


var $0dfcfd4187e724ef$export$2e2bcd8739ae039 = `
attribute vec4 aVertexPosition;
attribute vec2 aTextureCoord;
 
uniform mat4 uModelViewMatrix;
uniform mat4 uProjectionMatrix;

varying vec2 vTextureCoord;
 
void main() {
  // Multiply the position by the matrix.
  gl_Position = uProjectionMatrix * uModelViewMatrix * aVertexPosition;
 
  // Pass the texcoord to the fragment shader.
  vTextureCoord = aTextureCoord;
}
`;


function $b7a75298e1151217$var$loadShader(gl, type, code) {
    const shader = gl.createShader(type); //create shader
    gl.shaderSource(shader, code); //send source code to shader
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        alert("Error compiling shader: " + gl.getShaderInfoLog(shader));
        gl.deleteShader(shader);
        return null;
    }
    return shader;
}
function $b7a75298e1151217$export$227d3c439f40dcb4(gl, vsSource, fsSource) {
    const vertexShader = $b7a75298e1151217$var$loadShader(gl, gl.VERTEX_SHADER, vsSource); //load both vertex and fragment shaders
    const fragmentShader = $b7a75298e1151217$var$loadShader(gl, gl.FRAGMENT_SHADER, fsSource);
    const shaderProgram = gl.createProgram(); //create shader program and attach newly created shaders
    gl.attachShader(shaderProgram, vertexShader);
    gl.attachShader(shaderProgram, fragmentShader);
    gl.linkProgram(shaderProgram);
    if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) {
        alert("Error initializing program: " + gl.getProgramInfoLog(shaderProgram));
        return null;
    }
    return shaderProgram;
}


function $ab5e4f4adc1804d9$export$ec5db564352962b(gl) {
    const positionBuffer = $ab5e4f4adc1804d9$var$initPositionBuffer(gl);
    //const colorBuffer = initColorBuffer(gl);
    const indexBuffer = $ab5e4f4adc1804d9$var$initIndexBuffer(gl);
    const textureCoordBuffer = $ab5e4f4adc1804d9$var$initTextureBuffer(gl);
    return {
        position: positionBuffer,
        //color: colorBuffer,
        textureCoord: textureCoordBuffer,
        indices: indexBuffer
    };
}
function $ab5e4f4adc1804d9$var$initIndexBuffer(gl) {
    const indexBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
    // This array defines each face as two triangles, using the
    // indices into the vertex array to specify each triangle's
    // position.
    const indices = [
        0,
        1,
        2,
        0,
        2,
        3,
        4,
        5,
        6,
        4,
        6,
        7,
        8,
        9,
        10,
        8,
        10,
        11,
        12,
        13,
        14,
        12,
        14,
        15,
        16,
        17,
        18,
        16,
        18,
        19,
        20,
        21,
        22,
        20,
        22,
        23
    ];
    // Now send the element array to GL
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices), gl.STATIC_DRAW);
    return indexBuffer;
}
function $ab5e4f4adc1804d9$var$initColorBuffer(gl) {
    const faceColors = [
        [
            1.0,
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0
        ]
    ];
    // Convert the array of colors into a table for all the vertices.
    var colors = [];
    for(var j = 0; j < faceColors.length; ++j){
        const c = faceColors[j];
        // Repeat each color four times for the four vertices of the face
        colors = colors.concat(c, c, c, c);
    }
    const colorBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(colors), gl.STATIC_DRAW);
    return colorBuffer;
}
function $ab5e4f4adc1804d9$var$initPositionBuffer(gl) {
    const positionBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    const positions = [
        // Front face
        -1,
        -1,
        1.0,
        1.0,
        -1,
        1.0,
        1.0,
        1.0,
        1.0,
        -1,
        1.0,
        1.0,
        // Back face
        -1,
        -1,
        -1,
        -1,
        1.0,
        -1,
        1.0,
        1.0,
        -1,
        1.0,
        -1,
        -1,
        // Top face
        -1,
        1.0,
        -1,
        -1,
        1.0,
        1.0,
        1.0,
        1.0,
        1.0,
        1.0,
        1.0,
        -1,
        // Bottom face
        -1,
        -1,
        -1,
        1.0,
        -1,
        -1,
        1.0,
        -1,
        1.0,
        -1,
        -1,
        1.0,
        // Right face
        1.0,
        -1,
        -1,
        1.0,
        1.0,
        -1,
        1.0,
        1.0,
        1.0,
        1.0,
        -1,
        1.0,
        // Left face
        -1,
        -1,
        -1,
        -1,
        -1,
        1.0,
        -1,
        1.0,
        1.0,
        -1,
        1.0,
        -1
    ];
    // gl.bufferData(target, srcData, usage)
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(positions), gl.STATIC_DRAW);
    return positionBuffer;
}
function $ab5e4f4adc1804d9$var$initTextureBuffer(gl) {
    const textureCoordBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, textureCoordBuffer);
    const textureCoordinates = [
        // Front
        0.0,
        0.0,
        1.0,
        0.0,
        1.0,
        1.0,
        0.0,
        1.0,
        // Back
        0.0,
        0.0,
        1.0,
        0.0,
        1.0,
        1.0,
        0.0,
        1.0,
        // Top
        0.0,
        0.0,
        1.0,
        0.0,
        1.0,
        1.0,
        0.0,
        1.0,
        // Bottom
        0.0,
        0.0,
        1.0,
        0.0,
        1.0,
        1.0,
        0.0,
        1.0,
        // Right
        0.0,
        0.0,
        1.0,
        0.0,
        1.0,
        1.0,
        0.0,
        1.0,
        // Left
        0.0,
        0.0,
        1.0,
        0.0,
        1.0,
        1.0,
        0.0,
        1.0
    ];
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(textureCoordinates), gl.STATIC_DRAW);
    return textureCoordBuffer;
}


function $c3f39802e94e22cb$export$9ace2719e23fc1c2(gl, programInfo, buffers, texture, cameraRotation) {
    gl.clearColor(0.0, 0.0, 0.0, 1.0);
    gl.clearDepth(1.0);
    gl.enable(gl.DEPTH_TEST); // Enable depth testing
    gl.depthFunc(gl.LEQUAL); // Near things obscure far things
    //clear canvas colors and depth buffer
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
    // Create a perspective matrix, a special matrix that is
    // used to simulate the distortion of perspective in a camera.
    const fieldOfView = 45 * Math.PI / 180; // field of view in radians
    const aspect = gl.canvas.clientWidth / gl.canvas.clientHeight; // aspect ratio
    const zNear = 0.1; // clipping mask start
    const zFar = 100.0; // clipping mask end
    const projectionMatrix = mat4.create();
    // first argument is the target matrix
    mat4.perspective(projectionMatrix, fieldOfView, aspect, zNear, zFar);
    const modelViewMatrix = mat4.create();
    mat4.translate(modelViewMatrix, modelViewMatrix, [
        -0,
        0.0,
        -6
    ]);
    mat4.rotate(modelViewMatrix, modelViewMatrix, cameraRotation * Math.PI / 60, [
        0,
        0,
        1
    ] // axis
    );
    mat4.rotate(modelViewMatrix, modelViewMatrix, cameraRotation * Math.PI / 30, [
        0,
        1,
        0
    ] // axis
    );
    $c3f39802e94e22cb$var$setPositionAttribute(gl, buffers, programInfo);
    $c3f39802e94e22cb$var$setTextureAttribute(gl, buffers, programInfo);
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buffers.indices);
    gl.useProgram(programInfo.program);
    // Set the shader uniforms
    gl.uniformMatrix4fv(programInfo.uniformLocations.projectionMatrix, false, projectionMatrix);
    gl.uniformMatrix4fv(programInfo.uniformLocations.modelViewMatrix, false, modelViewMatrix);
    // Tell WebGL we want to affect texture unit 0
    gl.activeTexture(gl.TEXTURE0);
    // Bind the texture to texture unit 0
    gl.bindTexture(gl.TEXTURE_2D, texture);
    // Tell the shader we bound the texture to texture unit 0
    gl.uniform1i(programInfo.uniformLocations.uSampler, 0);
    {
        const vertexCount = 36;
        const type = gl.UNSIGNED_SHORT;
        const offset = 0;
        gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
    }
}
// Tell WebGL how to pull out the positions from the position
// buffer into the vertexPosition attribute.
function $c3f39802e94e22cb$var$setPositionAttribute(gl, buffers, programInfo) {
    const numComponents = 3; // 3d : x,y,z
    const type = gl.FLOAT; // the data in the buffer is 32bit floats
    const normalize = false; // don't normalize
    const stride = 0; // how many bytes to get from one set of values to the next
    // 0 = use type and numComponents above
    const offset = 0; // how many bytes inside the buffer to start from
    gl.bindBuffer(gl.ARRAY_BUFFER, buffers.position);
    gl.vertexAttribPointer(programInfo.attribLocations.vertexPosition, numComponents, type, normalize, stride, offset);
    gl.enableVertexAttribArray(programInfo.attribLocations.vertexPosition);
}
function $c3f39802e94e22cb$var$setColorAttribute(gl, buffers, programInfo) {
    const numComponents = 4; // rgb, alpha
    const type = gl.FLOAT;
    const normalize = false;
    const stride = 0;
    const offset = 0;
    gl.bindBuffer(gl.ARRAY_BUFFER, buffers.color);
    gl.vertexAttribPointer(programInfo.attribLocations.vertexColor, numComponents, type, normalize, stride, offset);
    gl.enableVertexAttribArray(programInfo.attribLocations.vertexColor);
}
function $c3f39802e94e22cb$var$setTextureAttribute(gl, buffers, programInfo) {
    const num = 2; // every coordinate composed of 2 values
    const type = gl.FLOAT; // the data in the buffer is 32-bit float
    const normalize = false; // don't normalize
    const stride = 0; // how many bytes to get from one set to the next
    const offset = 0; // how many bytes inside the buffer to start from
    gl.bindBuffer(gl.ARRAY_BUFFER, buffers.textureCoord);
    gl.vertexAttribPointer(programInfo.attribLocations.textureCoord, num, type, normalize, stride, offset);
    gl.enableVertexAttribArray(programInfo.attribLocations.textureCoord);
}


function $9b517937747fe432$export$19de0130f5adf0ae(gl, url) {
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    // Because images have to be downloaded over the internet
    // they might take a moment until they are ready.
    // Until then put a single pixel in the texture so we can
    // use it immediately. When the image has finished downloading
    // we'll update the texture with the contents of the image.
    const level = 0;
    const internalFormat = gl.RGBA;
    const width = 1;
    const height = 1;
    const border = 0;
    const srcFormat = gl.RGBA;
    const srcType = gl.UNSIGNED_BYTE;
    const pixel = new Uint8Array([
        0,
        255,
        255,
        255
    ]); // teal
    gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, width, height, border, srcFormat, srcType, pixel);
    const image = new Image();
    image.onload = ()=>{
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, image);
        // WebGL1 has different requirements for power of 2 images
        // vs. non power of 2 images so check if the image is a
        // power of 2 in both dimensions.
        if ($9b517937747fe432$var$isPowerOf2(image.width) && $9b517937747fe432$var$isPowerOf2(image.height)) // Yes, it's a power of 2. Generate mips.
        gl.generateMipmap(gl.TEXTURE_2D);
        else {
            // No, it's not a power of 2. Turn off mips and set
            // wrapping to clamp to edge
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        }
    };
    image.src = url;
    console.log(image);
    return texture;
}
function $9b517937747fe432$var$isPowerOf2(value) {
    return (value & value - 1) === 0;
}


document.addEventListener("DOMContentLoaded", ()=>{
    console.log("Document loaded.");
});
let $57b9e7254bf3106e$var$cameraRotation = 0.0;
let $57b9e7254bf3106e$var$deltaTime = 0;

function $57b9e7254bf3106e$var$main() {
    const canvas = document.querySelector("#glcanvas");
    const gl = canvas.getContext("webgl");
    if (gl === null) {
        alert("Unable to initialize WebGL. Your browser or machine may not support it.");
        return;
    }
    const shaderProgram = (0, $b7a75298e1151217$export$227d3c439f40dcb4)(gl, (0, $0dfcfd4187e724ef$export$2e2bcd8739ae039), (0, $130b0873670d25cf$export$2e2bcd8739ae039));
    const programInfo = {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
            textureCoord: gl.getAttribLocation(shaderProgram, "aTextureCoord")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            uSampler: gl.getUniformLocation(shaderProgram, "uSampler")
        }
    };
    const buffers = (0, $ab5e4f4adc1804d9$export$ec5db564352962b)(gl);
    // Load texture
    const texture = (0, $9b517937747fe432$export$19de0130f5adf0ae)(gl, (parcelRequire("84XYd")));
    // Flip image pixels into the bottom-to-top order that WebGL expects.
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
    console.log(texture);
    let then = 0;
    function render(now) {
        now *= 0.001; // convert to seconds
        $57b9e7254bf3106e$var$deltaTime = now - then;
        then = now;
        (0, $c3f39802e94e22cb$export$9ace2719e23fc1c2)(gl, programInfo, buffers, texture, $57b9e7254bf3106e$var$cameraRotation);
        $57b9e7254bf3106e$var$cameraRotation += $57b9e7254bf3106e$var$deltaTime;
        requestAnimationFrame(render);
    }
    requestAnimationFrame(render);
}
$57b9e7254bf3106e$var$main();

})();
//# sourceMappingURL=index.0990d8cb.js.map
